export function createContextManager() {
  var context = {};
  return {
    get: function get() {
      return context;
    },
    add: function add(key, value) {
      context[key] = value;
    },
    remove: function remove(key) {
      delete context[key];
    },
    set: function set(newContext) {
      context = newContext;
    }
  };
}